import { QuickLinkItem } from "./QuickLinkItem";
import qStyle from "./quicklink.module.scss";
import classNames from "classnames";

const QuickLinkData = [
  {
    title: "Calculators",
    icon: "Calculator",
    logged: true,
    link: "/calculator",
  },
  {
    title: "Resources",
    icon: "Resources",
    logged: false,
    link: "/resources",
  },
  {
    title: "Favourites",
    icon: "Star",
    logged: true,
    link: "/app/favourites",
  },
];

const WhatsNewItems = [
  {
    title: "What's new",
    logged: false,
    link: "/updates",
    documents: false,
  },
];

export const QuickLinks = ({ isLogged }) => {
  return (
    <div className={classNames("container", qStyle.quicklinkContainer)}>
      <div className={qStyle.quicklinkSection}>
        {QuickLinkData.filter(({ logged }) => (isLogged && logged) || !logged).map(
          ({ icon, title, link }, index) => (
            <a
              href={link}
              key={index}
              className={classNames("size-12 semibold", qStyle.quicklinkBox)}
            >
              <i className={`tg-icons-${icon} size-16`}></i>
              <div>{title}</div>
            </a>
          ),
        )}
      </div>
      {WhatsNewItems.filter(({ logged }) => (isLogged && logged) || !logged).map(
        ({ icon, description, title, link, documents }, index) => (
          <QuickLinkItem
            {...{ icon, description, title, link, documents }}
            className="centered"
            key={`quick-${index}`}
          ></QuickLinkItem>
        ),
      )}
    </div>
  );
};
